import React from "react";

export const ChooseVerificationSkeletonLoader = () => {
  return (
    <div className="l1-relative l1-mx-auto l1-flex l1-w-full l1-max-w-[373px] l1-animate-pulse l1-flex-col l1-items-center l1-gap-8 l1-py-5">
      {/* This is added to hide top rounded corner in Modal */}
      {window.innerWidth < 768 ? (
        <div className="l1-fixed !l1-h-4 l1-bg-white left-0 top-0 w-full"></div>
      ) : null}
      <div className="l1-mt-4 l1-flex l1-w-full l1-flex-col l1-items-center l1-justify-center l1-gap-6 md:l1-px-4 l1-px-6">
        <div className="l1-h-[72px] l1-w-[72px] l1-rounded-full l1-bg-slate-200"></div>
        <p className="l1-h-[26px] l1-w-full l1-bg-slate-200"></p>
      </div>
      <div className="l1-flex l1-w-full l1-flex-col l1-gap-4 md:l1-px-4 l1-px-6">
        <div className="l1-h-[52px] l1-w-full l1-rounded-lg l1-bg-slate-200"></div>
        <div className="l1-h-[52px] l1-w-full l1-rounded-lg l1-bg-slate-200"></div>
      </div>
    </div>
  );
};
